import React, { memo, useState } from 'react';
import { Add, Remove } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button';
import { Visibility } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import { formatDate } from 'hooks/Pipe';
import {
  Checkbox,
  Collapse,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';

function OrderItem(props) {
  const { order, setRoutes } = props;

  function handleChecked() {
    setRoutes((routes) => {
      let routeIndex = routes.findIndex((item) => item.id === parseInt(order.base_route_id));
      let newRoutes = [...routes];
      let index = newRoutes[routeIndex].orders.findIndex((item) => item.id === order.id);
      newRoutes[routeIndex].orders[index].checked = !!!newRoutes[routeIndex].orders[index].checked;
      return newRoutes;
    });
  }

  return (
    <TableRow>
      <TableCell>
        <FormControlLabel
          control={
            <Checkbox margin="normal" checked={order.checked === true} onChange={handleChecked} />
          }
        />
        <Button justIcon round simple color="primary">
          <Link to={`/admin/ventas/operaciones/pedidos/#${order.id}`} target="_blank">
            <Visibility />
          </Link>
        </Button>
      </TableCell>
      <TableCell>
        <p>{order.CardCode}</p>
        <p>{order.CardName}</p>
      </TableCell>
      <TableCell>S/ {parseFloat(order.total_order).toFixed(2)}</TableCell>
      <TableCell>{order.Address2} </TableCell>
      <TableCell>{formatDate(order.date_order, 'F')}</TableCell>
      <TableCell>{order.SlpName}</TableCell>
    </TableRow>
  );
}

function OrdersWithoutPoint(props) {
  const { routes, setRoutes } = props;
  const [collapsed, setCollapsed] = useState(true);

  return (
    <div style={{ overflow: 'scroll', maxHeight: '500px' }}>
      {routes.map((route) => {
        return (
          <div key={route.id}>
            <div style={{ display: 'flex' }}>
              <div style={{ flex: 1 }}>
                <h4>
                  <strong>
                    {route.code} {route.description}
                  </strong>{' '}
                  ({route.orders.length}) pedidos
                </h4>
              </div>
              <Button
                justIcon
                onClick={() => setCollapsed((collapse) => !collapse)}
                color="success"
              >
                {collapsed ? <Add /> : <Remove />}
              </Button>
            </div>
            <Collapse in={!collapsed}>
              <div style={{ overflow: 'scroll', maxHeight: '500px' }}>
                <Table style={{ minWidth: '1000px', width: '100%' }}>
                  <TableHead>
                    <TableRow>
                      <TableCell width={'100px'}></TableCell>
                      <TableCell width={'300px'}>Cliente</TableCell>
                      <TableCell width={'150px'}>Monto</TableCell>
                      <TableCell width={'200px'}>Dirección</TableCell>
                      <TableCell width={'150px'}>Fecha</TableCell>
                      <TableCell width={'200px'}>Vendedor</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {route.orders.map((order) => {
                      return <OrderItem key={order.id} order={order} setRoutes={setRoutes} />;
                    })}
                  </TableBody>
                </Table>
              </div>
            </Collapse>
          </div>
        );
      })}
    </div>
  );
}

export default memo(OrdersWithoutPoint);
